// extracted by mini-css-extract-plugin
module.exports = {"modal":"DirectorModal_modal__SCaZt","content":"DirectorModal_content__kr4gq","link":"DirectorModal_link__6y6mB","button":"DirectorModal_button__OsKv4"};